export interface MenuItem {
  name: string;
  icon?: string;
  link: string;
  opened?: boolean;
  children?: MenuItem[];
}

export const Menus: MenuItem[] = [
  { name: 'Dashboard', icon: 'si si-speedometer', link: '' },
  { name: 'My Schedule', icon: 'si si-calendar', link: 'schedule' },
  {
    name: 'Events', icon: 'si si-trophy',
    link: 'events',
    children: [
      {
        name: 'Event List',
        link: 'list',
        children: [
          { name: 'Registration', link: 'registration' },
          { name: 'Schedule', link: 'schedule' },
          { name: 'Teams', link: 'teams' },
        ]
      },
      {
        name: 'Assignments',
        link: 'assignments',
        children: [
          { name: 'By Games', link: 'by-games' },
          { name: 'By Players', link: 'by-players' }
        ]
      }
    ]
  },
  { name: 'Clubs', icon: 'si si-list', link: 'clubs' },
  {
    name: 'Players',
    icon: 'si si-users',
    link: 'players',
    children: [
      { name: 'Dashboard', link: 'dashboard' },
      { name: 'All Players', link: 'players' },
      { name: 'Our Recruits', link: 'recruits' },
    ]
  },
  {
    name: 'My Camps',
    icon: 'si si-layers',
    link: 'camps',
    children: [
      { name: 'Dashboard', link: 'dashboard' },
      { name: 'Camp Listings', link: 'listings' },
      { name: 'Camp Marketing', link: 'marketing' },
    ]
  },
  { name: 'Compliance', icon: 'si si-doc', link: 'compliance' },
  { name: 'My School', icon: 'si si-graduation', link: 'school' },
];



// WEBPACK FOOTER //
// ./src/app/models/menu.config.ts